import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline'

export default function RestCard({ phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    function formatTime(seconds) {
        let minutes = Math.floor(seconds / 60)
        let remainingSeconds = seconds % 60

        // Pad the minutes and seconds with leading zeros, if required
        minutes = String(minutes).padStart(2, '0')
        remainingSeconds = String(remainingSeconds).padStart(2, '0')

        return `${minutes}:${remainingSeconds}`
    }

    switch (mode) {
        // Edit mode
        case 'edit':
            return (
                <div className="flex items-center h-6 border-stone-400 border-t text-xs bg-gray-100 rounded-b-lg">
                    {/* Time Changer Component */}
                    <div className="h-6 flex flex-grow justify-center items-center text-center gap-x-1 text-xs">
                        <button onClick={() => mutateExercise('subtract-rest-seconds', phaseIndex, exerciseIndex)}>
                            <MinusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
                        </button>

                        <p>{formatTime(exercise.restSecondsAfterExercise)}</p>

                        <button onClick={() => mutateExercise('add-rest-seconds', phaseIndex, exerciseIndex)}>
                            <PlusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
                        </button>
                    </div>
                </div>
            )

        // View mode
        case 'view':
            return (
                <div className="flex items-center h-6 border-stone-400 border-t text-xs bg-gray-100 rounded-b-lg">
                    <p className="flex-grow text-center">{formatTime(exercise.restSecondsAfterExercise)} Rest</p>
                </div>
            )

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
